import { Stroke, Style } from "ol/style";
import { extractTags } from "./propertyExtraction";

export function getHDLaneRestrictionStyleNormal(feature) {
  return getHDLaneRestrictionColorStyle(feature);
}

export function getHDLaneRestrictionStyleClick(feature) {
  return getHDLaneRestrictionColorStyle(feature, true, false);
}

export function getHDLaneRestrictionStyleHover(feature) {
  return getHDLaneRestrictionColorStyle(feature, false, true);
}

function getHDLaneRestrictionColorStyle(feature, click = false, hover = false) {
  const tags = extractTags(feature);
  if (
    tags.hdMap !== "lane_center_line" &&
    tags.hdMap !== "lane_trajectory_line"
  ) {
    return [
      new Style({
        stroke: new Stroke({
          color: "transparent",
          width: 0,
        }),
      }),
    ];
  }

  let color;
  let backgroundColor = "white";
  let width;
  let backgroundWidth;
  if (tags.vehicleRestrictionBus === "yes") {
    color = "maroon";
    width = 4;
    backgroundWidth = 6;
  } else if (tags.vehicleRestrictionHGV === "yes") {
    color = "purple";
    width = 4;
    backgroundWidth = 6;
  } else if (tags.vehicleRestrictionPSV === "yes") {
    color = "blue";
    width = 4;
    backgroundWidth = 6;
  } else if (tags.vehicleRestrictionTaxi === "yes") {
    color = "yellow";
    width = 4;
    backgroundWidth = 6;
  } else if (tags.hovLane === "yes" || tags.hov === "yes") {
    color = "orange";
    width = 4;
    backgroundWidth = 6;
  } else if (
    tags.vehicleRestrictionMotorVehicle !== undefined &&
    tags.vehicleRestrictionMotorVehicle !== "yes"
  ) {
    color = "darkgrey";
    width = 4;
    backgroundWidth = 6;
  } else {
    color = "grey";
    width = 1;
    backgroundWidth = 2;
  }

  if (hover || click) {
    backgroundWidth = 6;
    return [
      new Style({
        stroke: new Stroke({
          color: backgroundColor,
          width: backgroundWidth,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: color,
          width: width,
        }),
      }),
    ];
  }
  return [
    new Style({
      stroke: new Stroke({
        color: backgroundColor,
        width: backgroundWidth,
      }),
    }),
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    }),
  ];
}
